( function () {
	'use strict';

	/*
	 * Observations Table Directive
	 *
	 * Usage:
	 *     <obs-table class="animate-switch" ng-switch-default data-date-type="Submitted" data-list-type="submitted"></obs-table>
	 *     <obs-table class="animate-switch" ng-switch-when="in-progress" data-date-type="Started" data-list-type="inprogress"></obs-table>
	 */
	function ObsTable () {
		var directiveData = {
			'restrict'     : 'E',
			'templateUrl'  : '/templates/observations/observations-list/obs-table.html',
			'controller'   : 'ObsTableCtrl',
			'controllerAs' : 'vm',
			'scope'        : {
				'dateType'     : '@',
				'startDate'    : '=',
				'endDate'      : '=',
				'listType'     : '@',
				'searchText'   : '=',
				'searchFilter' : '='
			}
		};

		return directiveData;
	}

	angular
	.module( 'app.observations' )
	.directive( 'obsTable', ObsTable );

	ObsTable.$inject = [ '$q', 'coreservice', 'logger', 'observationsApi', 'INFO', 'ERROR_MSGS' ];
} )();
